module.exports = __webpack_public_path__ + "public/images/icons/space.832a5eff8b904ffd038d193dd8c47d03.png";